import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import { Grid, CardHeader, CardActionArea } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  media: {
    height: 140,
    backgroundSize: "contain",
  },
  outer: {
    width: `100%`,
    height: "16rem",
    margin: "0",
    position: "relative",
  },
  header: {
    margin: 0,
    [theme.breakpoints.up("md")]: {
      margin: "5px",
      padding: "5px 2px",
    },
  },
}));

export default function QuotaManagementCard(props) {
  const classes = useStyles();

  let id = props.header.replace(/ & /g, ' and ')
  id = id.replace(/[()]/g, "")
  id = id.replace(/ + /g, "")

  return (
    <CardActionArea>
      <Card
        raised={true}
        className={classes.outer}
        id={`navlink_${id.split(" ").join("_")}`}
        style={{ position: "relative" }}
      >
        {/* Clickable overlay for the entire card */}
        <div
          style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            cursor: "pointer",
            zIndex: 1,
          }}
          onClick={() => props.onClick && props.onClick()}
        ></div>

        <CardHeader
          style={{ padding: 0, margin: 0, cursor: "pointer", zIndex: 2 }}
          title={
            <Typography
              style={{ cursor: "pointer" }}
              className={classes.header}
              variant="h2"
              component="h2"
              align="center"
            >
              {props.header}
            </Typography>
          }
        />

        <CardContent
          style={{ width: "100%", cursor: "pointer", zIndex: 2 }}
        >
          <Grid container>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <Typography variant="body1" color="textSecondary">
                {props.text}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <CardMedia
                className={classes.media}
                image={props.image}
                title={props.header}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </CardActionArea>
  );
}
